export default __webpack_public_path__ + "static/media/main_image.7deeb108.png";